const RatingIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 13.5L5.62321 9.43965C5.78185 9.28342 6.02968 9.2658 6.20854 9.3981L9.39292 11.7534C9.5805 11.8922 9.84217 11.8653 9.99795 11.6912L15.9637 5.02697M13.5813 4.5H15.6979C16.1089 4.5 16.4444 4.83058 16.4528 5.24384L16.5 7.54868"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default RatingIcon;
